var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg75",
    height: 105,
    width: 125,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs79"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter452",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood442",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.498039
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite444",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur446",
    result: "blur",
    stdDeviation: 6.2,
    in: "composite1"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset448",
    result: "offset",
    dy: -20.8333,
    dx: -3.4
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite450",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter464",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood454",
    result: "flood",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.498039
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite456",
    result: "composite1",
    operator: "in",
    in2: "SourceGraphic",
    in: "flood"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur458",
    result: "blur",
    stdDeviation: 6.2,
    in: "composite1"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset460",
    result: "offset",
    dy: -20.8333,
    dx: -3.4
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    id: "feComposite462",
    result: "composite2",
    operator: "over",
    in2: "offset",
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g65"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title62"
  }, "background")), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    x: -1,
    y: -1,
    width: 582,
    height: 402,
    id: "canvas_background"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.27006294,0.04152078,-0.04152078,-0.27006294,101.66435,81.32555)",
    id: "g139"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#333333",
      fillOpacity: 1,
      filter: "url(#filter464)"
    },
    transform: "matrix(1.2708814,0,0,1.2708814,-53.233722,-47.815583)",
    id: "g83"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      fillOpacity: 1
    },
    d: "m 247.094,297 c -2.831,0 -5.549,-1.125 -7.551,-3.129 l -82.835,-82.868 -34.905,60.448 c -2.046,3.544 -5.936,5.61 -10.017,5.31 -4.081,-0.296 -7.634,-2.896 -9.148,-6.697 L 0.825,14.632 C -0.755,10.667 0.177,6.143 3.194,3.127 6.212,0.108 10.735,-0.82 14.7,0.761 l 255.317,101.86 c 3.799,1.515 6.397,5.067 6.693,9.148 0.295,4.079 -1.766,7.968 -5.308,10.015 l -60.435,34.929 82.839,82.878 c 4.168,4.169 4.168,10.926 0.001,15.096 l -39.162,39.186 c -2.002,2 -4.718,3.127 -7.551,3.127 z M 154.422,182.934 c 2.813,0 5.534,1.112 7.551,3.129 l 85.121,85.156 24.067,-24.082 -85.126,-85.162 c -2.347,-2.348 -3.469,-5.651 -3.036,-8.941 0.433,-3.291 2.371,-6.191 5.244,-7.852 L 241.67,114.303 29.86,29.801 114.322,241.703 145.175,188.27 c 1.66,-2.874 4.563,-4.813 7.854,-5.246 0.465,-0.06 0.93,-0.09 1.393,-0.09 z",
    id: "path81"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g85"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g87"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g89"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g91"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g93"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g95"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g97"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g99"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g101"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g103"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g105"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g107"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g109"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g111"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g113"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path171",
    d: "m 120.35841,44.711258 c 70.53752,28.267391 129.00514,51.798466 129.92804,52.291276 1.00252,0.535329 -12.20522,8.880596 -32.80986,20.730806 -23.24534,13.36895 -35.19505,21.00063 -36.65725,23.41117 -2.96748,4.89207 -2.49945,11.59557 1.12604,16.12808 1.65334,2.06697 26.62885,27.3293 55.50113,56.13849 28.87229,28.80921 52.42642,52.70064 52.34252,53.09208 -0.0839,0.39144 -6.63857,7.18306 -14.56595,15.0925 l -14.4134,14.38078 -54.76986,-54.7627 c -30.12342,-30.11948 -55.84597,-55.29569 -57.16121,-55.94713 -3.79201,-1.8782 -10.67494,-1.12147 -14.05714,1.54547 -1.70763,1.34652 -11.66624,17.33269 -22.13023,35.52482 -10.46398,18.19214 -19.475404,33.40669 -20.025374,33.81011 C 91.928378,256.688 13.682765,62.576642 -11.057108,-1.1685055 l -2.59761,-6.6930761 2.881523,0.5888001 C -9.1883269,-6.9489497 49.820884,16.443869 120.35841,44.711258 Z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1.29394829,
      filter: "url(#filter452)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.07ae379f.svg";
export { ForwardRef as ReactComponent };